import {roundNumber} from '@udemy/i18n';
import {serverOrClient} from '@udemy/shared-utils';

export {roundNumber};

interface DjangoFormats {
    DECIMAL_SEPARATOR: string;
    NUMBER_GROUPING: string | number | number[];
    THOUSAND_SEPARATOR: string;
}

interface GlobalWithDjango {
    django: {formats: DjangoFormats};
}

// JavaScript implementation of django.utils.numberformat#format.
export function formatNumber(
    number: number | string,
    options: {decimalPos?: number | null; forceGrouping?: boolean} = {},
) {
    // global.django.formats is defined in the jsi18n file, which is generated by Django.
    const djangoFormats = (serverOrClient.global as unknown as GlobalWithDjango).django.formats;
    const grouping = djangoFormats.NUMBER_GROUPING;
    const thousandSep = djangoFormats.THOUSAND_SEPARATOR;

    const {decimalPos = null, forceGrouping = true} = options;

    const useGrouping = forceGrouping && grouping !== '0';
    if (!useGrouping && !decimalPos) {
        return `${number}`;
    }

    let sign = '';
    let strNumber = `${number}`;
    if (strNumber[0] === '-') {
        sign = '-';
        strNumber = strNumber.substring(1);
    }

    let intPart: string | undefined, decPart: string;
    if (strNumber.includes('.')) {
        [intPart, decPart] = strNumber.split('.');
        if (decimalPos !== null) {
            decPart = decPart.substring(0, decimalPos);
        }
    } else {
        [intPart, decPart] = [strNumber, ''];
    }
    if (decimalPos !== null) {
        for (let i = 0; i < decimalPos - decPart.length; i++) {
            decPart += '0';
        }
    }
    if (decPart) {
        decPart = djangoFormats.DECIMAL_SEPARATOR + decPart;
    }

    if (useGrouping) {
        let intervals: (string | number)[];
        if (Array.isArray(grouping)) {
            intervals = [...grouping];
        } else {
            intervals = [grouping, 0];
        }
        let activeInterval = intervals.shift();
        let intPartGD = '';
        let cnt = 0;
        (intPart ?? '')
            .split('')
            .reverse()
            .forEach((digit) => {
                activeInterval = parseInt(`${activeInterval}`, 10);
                if (cnt && cnt === activeInterval) {
                    if (intervals.length > 0) {
                        // 0 means "repeat the previous interval" (Django convention)
                        activeInterval = intervals.shift() || activeInterval;
                    }
                    intPartGD += thousandSep.split('').reverse().join('');
                    cnt = 0;
                }
                intPartGD += digit;
                cnt += 1;
            });
        intPart = intPartGD.split('').reverse().join('');
    }

    return sign + (intPart ?? '') + decPart;
}

export function formatRoundNumber(number: number, precision = 0) {
    return formatNumber(roundNumber(number, precision).toFixed(precision));
}
